import styled from '../styled-components';

interface Props {
    primary: boolean;
    normal: boolean;
}

export default styled<Props, any>('button')`
    display: inline-block;
    padding: 0.6em 1.4em 0.7em;
    border: 0 none;
    border-radius: 0.1em;
    font-weight: 500;
    color: ${p => p.theme.textInverted};
    background-color: ${props => (props.normal ? props.theme.gray : props.theme.primary)};
    transition: transform 0.1s ease-out;
    transform: translateY(0);
    box-sizing: border-box;
    cursor: pointer;

    &:hover {
        transform: translateY(-1px);
    }

    &:active {
        transform: translateY(1px);
    }

    @media (max-width: 380px) {
        width: 100%;
        text-align: center;
    }
`;



// WEBPACK FOOTER //
// ./src/components/Button.tsx